/**
 * Do not edit directly
 * Generated on Fri, 23 Jun 2023 09:14:33 GMT
 */

export const shadows = {
  sm: '0px 0px 10px 0px rgba(191, 191, 191, 0.5)',
  md: '0px 0px 20px 0px rgba(104, 104, 104, 0.3)',
}
